import React from "react";
import "./TabletSearchPopUp.css";

function TabletSearchPopUp() {
  return (
    <div className="container-center-horizontal">
      <div className="tablet-search-pop-up screen"></div>
    </div>
  );
}

export default TabletSearchPopUp;
